<div class="sh-progress-dots-container">
	<prism-progress-dots></prism-progress-dots>
</div>
